import {HTTP} from './httpSvc'

const loginUrl = 'login/access-token'
const meUrl = 'accounts/me'
const resetPasswordUrl = 'reset-password/'

export const doLogin = (username, password) => {
  const data = new FormData()
  data.append('username', username)
  data.append('password', password)
  return HTTP.postFormData(loginUrl, data).then(res => {
    if (res && res.data && res.data.access_token) {
      localStorage.setItem('accessToken', res.data.access_token)
      return res
    } else {
      throw new Error('login failed')
    }
  })
}


export const me = () => HTTP.get(meUrl).then(meRes => {
  if (meRes && meRes.data && meRes.data.id) {
    localStorage.setItem('accountId', meRes.data.id)
    return meRes
  } else {
    throw new Error('failed to load me')
  }  
})

export const doLogout = () => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('accountId')
}

export const passwordReset = (token, pwd) => {
  const data = {
    token,
    new_password: pwd
  }
  return HTTP.postJson(resetPasswordUrl, data)
}